import { render, staticRenderFns } from "./TiempoParosMensual.vue?vue&type=template&id=3367a512&"
import script from "./TiempoParosMensual.vue?vue&type=script&lang=js&"
export * from "./TiempoParosMensual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports